import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import resetReducer from "./passResetSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import {thunk} from "redux-thunk";
import { combineReducers } from "redux";

const persistConfig = {
  key: "root",
  storage,
};

const rootReducer = combineReducers({
  user: userReducer,
  reset: resetReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const storeParamarsh = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

export default storeParamarsh;
